import {
  initialState,
  Actions,
  State,
  NEW_ELEMENT,
  NEW_ELEMENT_SUCCESS,
  NEW_ELEMENT_ERROR,
  RESET_NEW_ELEMENT,
} from '../../types/element/new'

const reducers = (state = initialState, action: Actions<any>): State<any> => {
  switch (action.type) {
    case NEW_ELEMENT:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case NEW_ELEMENT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case NEW_ELEMENT_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_NEW_ELEMENT:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
